// Generated by packages/ui/scripts/build-app-sprite.mjs - do not edit manually
export const spriteUrl = '/forms/sprite.6d01c5c5f8be.svg' as const;
